export default {
  subjectTypes(state) {
    return state.subjectTypes
  },
  markers(state) {
    return state.markers
  },
  markersLoading(state) {
    return state.markersLoading
  },
  loadingError(state) {
    return state.loadingError
  },
  markersLoaded(state) {
    return state.markersLoaded
  },
  mailingGroups(state) {
    return state.mailingGroups
  },
}
